"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VStep = exports.StepContext = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ButtonsBar_1 = __importDefault(require("./components/Buttons/ButtonsBar"));
var ChildrenDiv = (0, styled_components_1.default)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin: 10px 0;\n"], ["\n  display: flex;\n  justify-content: center;\n  margin: 10px 0;\n"])));
exports.StepContext = react_1.default.createContext({});
var VStep = function (props) {
    var pp = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, pp.isActive && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ChildrenDiv, null, props.component
            ? react_1.default.createElement(props.component)
            : props.children),
        react_1.default.createElement(exports.StepContext.Provider, { value: __assign({}, props) },
            react_1.default.createElement(ButtonsBar_1.default, null))))));
};
exports.VStep = VStep;
var templateObject_1;
